import isEmpty from 'lodash/isEmpty';

import { removeZipCodeFromAddress } from 'shared/lib/addressFields';
import type { TCustomerUpdateData } from 'shared/types/TCustomerService';
import type { TDataCity } from 'shared/types/TUserAddressFields';

export class Region {
  constructor(
    private readonly region: Nullable<Dictionaries.TSelectValue<string, TDataCity>> | undefined,
    private readonly locationRoute?: string | null,
    // eslint-disable-next-line no-empty-function
  ) {}

  map(): NonNullable<TCustomerUpdateData['region']> | null {
    if (!this.region || isEmpty(this.region)) {
      return null;
    }

    const { data, value } = this.region || {};
    const { city_fias_id, fias_id } = data || {};

    return {
      unrestricted_value: value || '',
      fias_id: city_fias_id || fias_id || '',
      restricted_value: removeZipCodeFromAddress(value || ''),
      // todo убрать каст после обновления типов в customerService
      location_route: (this.locationRoute || null) as NonNullable<TCustomerUpdateData['region']>['location_route'],
    };
  }
}
